import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Dropdown } from 'antd'; // Import Ant Design components

import { AppHeaderAdmin, AppHeaderDefault, BaseButtonFill, BaseIcon } from 'bxcommon';
import { clearForm } from '../../store/slices/request.slice';
import { setUserGroup } from '../../store/slices/selectedUserGroup.slice';

import './ProspectusHeader.scss'; // Import your custom styles

export const ProspectusHeader = ({ children }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();
  const loggedIn = useSelector((state) => state.user.loggedIn);

  // Handler to clear form before navigation
  const handleMenuClick = (path) => {
    dispatch(clearForm());
    navigate(path);
  };

  // Define menu items for the Ant Design dropdown
  const items = [
    {
      key: 'equity',
      label: 'Equity security',
      icon: <BaseIcon icon="equity" style={{ width: 16, marginRight: 8 }} />,
      onClick: () => handleMenuClick('/request/equity'),
    },
    {
      key: 'debt',
      label: 'Debt security',
      icon: <BaseIcon icon="debt" style={{ width: 16, marginRight: 8 }} />,
      onClick: () => handleMenuClick('/request/debt'),
    },
    {
      key: 'derivative',
      label: 'Derivative security',
      icon: <BaseIcon icon="derivative" style={{ width: 16, marginRight: 8 }} />,
      onClick: () => handleMenuClick('/request/derivative'),
    },
  ];

  const addNewProspectus = loggedIn && (
    <div className="app-header__new-request">
      <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
        <Button
          type="primary"
          data-testid="header-add-request"
          style={{
            backgroundColor: '#4f2d7f', // Purple color matching your UI
            display: 'flex',
            alignItems: 'space-between',
          }}
        >
          {t('list.buttons.createNewRequest')}
          <BaseIcon icon="add" className="base-icon--white" style={{ marginLeft: 8 }} />
        </Button>
      </Dropdown>
    </div>
  );

  const clearAndGoToGroup = () => {
    dispatch(setUserGroup({}));
    navigate('/groups/edit');
  };

  const createNewUserGroup = loggedIn && (
    <div className="app-header__new-request">
      <BaseButtonFill iconRight icon="add" data-testid="header-create-group" onClick={clearAndGoToGroup}>
        {t('userGroups.buttons.create')}
      </BaseButtonFill>
    </div>
  );

  return (
    <AppHeaderDefault
      adminHeader={<AppHeaderAdmin isProspectus />}
      controls={location.pathname.includes('/groups') ? createNewUserGroup : addNewProspectus}
    >
      {children}
    </AppHeaderDefault>
  );
};

export default ProspectusHeader;
